import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Translation } from "@jsverse/transloco";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { CmsProjectGroup, CmsProjectGroupByKey, CmsProjectGroupByTag } from "../models/cms-data.model";

@Injectable({
    providedIn: "root",
})
export class CmsDataService {
    private http = inject(HttpClient);

    getCmsTextByKey$(key: string): Observable<any> {
        return this.http.get(`${environment.backendUrl}/Cms/Text`, { params: { key }, responseType: "text" })
    }

    getCmsGroupByKey$(key: string, lang: string = "da_DK"): Observable<CmsProjectGroupByKey> {
        return this.http.get<CmsProjectGroupByKey>(`${environment.backendUrl}/Cms/GroupDataByKey`, { params: { key, lang } });
    }

    getCmsProjectGroupByTag$(tag: string, onlyActiveEntries: boolean = true, lang: string = "da_DK"): Observable<CmsProjectGroupByTag[]> {
        return this.http.get<CmsProjectGroupByTag[]>(`${environment.backendUrl}/Cms/GroupDataByTag`, { params: { tag, onlyActiveEntries, lang } });
    }

    getCmsProjectGroups$(): Observable<CmsProjectGroup[]> {
        return this.http.get<CmsProjectGroup[]>(`${environment.backendUrl}/Cms/ProjectGroups`);
    }

    getCmsDataAsJson$(lang: string): Observable<Translation> {
        return this.http.get<Translation>(`${environment.backendUrl}/Cms/ProjectDataJson`, { params: { lang } });
    }
}

